<template>
  <div>
    <CustomFdkAccount v-slot="accountsData">
      <JdsButton
        variant="secondary"
        size="medium"
        :fullWidth="isMobile"
        @click="openAddQuestionModal(accountsData)"
      >
        <!-- icon should be visible in desktop device only -->
        <template v-if="!isMobile" #icon>
          <JdsIcon
            name="HelpIcon"
            size="m"
            color="fe-text-primary-50"
            className="fe-mr-xs"
          />
        </template>
        Ask a question
      </JdsButton>
    </CustomFdkAccount>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import { responsiveMixin } from "@/mixins/responsiveMixin"
  import AskQuestionDialog from "@/components/QuestionAndAnswer/AskQuestionDialog/AskQuestionDialog.vue"

  export default {
    name: "AskQuestionCta",
    components: {
      JdsButton,
      JdsIcon,
      CustomFdkAccount,
    },
    mixins: [modalMixin, responsiveMixin],
    methods: {
      openAddQuestionModal(accountsData) {
        if (!accountsData?.is_logged_in) {
          accountsData.openLogin()

          return
        }

        this.openDialog(AskQuestionDialog)
      },
    },
  }
</script>
